export interface SiteTermsDto {
    areas: string
    buildings: string
    shifts: string
    skills: string
    skill_types: string
}

export interface SiteTerms {
    areas: string
    buildings: string
    shifts: string
    skills: string
    skill_types: string
    [key: string]: string
}

export const createTerms = (
    params: {
        areas: string
        buildings: string
        shifts: string
        skills: string
        skill_types: string
    }
): SiteTerms => ({
    areas: params.areas,
    buildings: params.buildings,
    shifts: params.shifts,
    skills: params.skills,
    skill_types: params.skill_types
})

export const termsFromDto = (dto: SiteTermsDto): SiteTerms => (createTerms({
    areas: dto.areas,
    buildings: dto.buildings,
    shifts: dto.shifts,
    skills: dto.skills,
    skill_types: dto.skill_types
}))